import React, { Component } from 'react';
import {
  change,
  Field,
  reduxForm,
  reset
} from 'redux-form';
import { browserHistory } from 'react-router';

import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withGoBack from '../../common/withGoBack';
import withOnline from '../../common/withOnline';
import withSurgeonNotes from '../../common/withSurgeonNotes';

import Header from '../../components/Header';
import Bugsnag from '../../helpers/bugsnag';

import {
  renderField,
  required,
} from '../../helpers/form-validations';
import {
  onGoBack,
} from '../../common/globals';
// import {
//   getPreferenceByName
// } from '../../utils/db';
import {
  removeSurgeonNotes,
  editSurgeonNotes,
  addSurgeonNotes
} from '../../utils/utils';

import ChooseSurgeon from './ChooseSurgeon';
import NoSaveSurgeonNoteModal from '../../components/Models/NoSaveSurgeonNoteModal';
import SaveSurgeonBackModal from '../../components/Models/SaveSurgeonBackModal';
import DeleteSurgeonNoteConfirmation from '../../components/Models/DeleteSurgeonNoteConfirmation';

class AddSurgeonNote extends Component {
  constructor(props) {
    super(props);

    this.state = {
      surgeonNote: {
        SurgeonName: '',
        NoteTitle: '',
        Note: '',
        ID: ''
      },
      fieldPageToShow: false,
      surgeonData: {}
    };

    this.NoSaveSurgeonNote = null;
    this.deleteSurgeonNote = null;
    this.saveSurgeonNoteOnBack = null;
  }

  componentDidMount() {
    try {
      this.NoSaveSurgeonNote = new window.bootstrap.Modal(
        window.$('#noSaveSurgeonNoteModal')
      );
      this.deleteSurgeonNote = new window.bootstrap.Modal(
        window.$('#deleteSurgeonNoteConfirmation')
      );
      this.saveSurgeonNoteOnBack = new window.bootstrap.Modal(
        window.$('#saveSurgeonBackModal')
      );
      window.scrollTo(0, 0);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBack = async () => {
    try {
      const { goBack, params } = this.props;
      const { fieldPageToShow } = this.state;

      const id = params.hasOwnProperty('id') ? params.id : '';
      if (id !== '') {
        this.saveSurgeonNoteOnBack.show();
      } else {
        if (fieldPageToShow) {
          this.NoSaveSurgeonNote.show();
        } else {
          onGoBack(goBack);
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onFieldSelected = async (value) => {
    try {
      this.setState({
        fieldPageToShow: true,
        surgeonData: value
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _noSaveSurgeonNoteYes = () => {
    try {
      const { dispatch, setSurgeonNote } = this.props;
      const { fieldPageToShow, surgeonNote } = this.state;
      this.setState({
        fieldPageToShow: !fieldPageToShow,
        surgeonNote: {
          ...surgeonNote,
          NoteTitle: '',
          Note: '',
          ID: ''
        }
      });

      setSurgeonNote({
        SurgeonName: '',
        NoteTitle: '',
        Note: '',
        ID: ''
      });

      dispatch(reset('surgeonNoteForm'));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onChangeName = (e) => {
    try {
      const { surgeonNote } = this.state;
      this.setState({
        surgeonNote: { ...surgeonNote, NoteTitle: e.target.value }
      });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeComments = (e) => {
    try {
      const { surgeonNote } = this.state;
      this.setState({
        surgeonNote: { ...surgeonNote, Note: e.target.value }
      });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onSubmit = async () => {
    try {
      const {
        notify, online, setLoader, dispatch, goBack
      } = this.props;
      const {
        surgeonNote, surgeonData
      } = this.state;

      if (online) {
        setLoader(true);

        if (surgeonNote.ID !== '') {
          const postData = {
            NoteTitle: surgeonNote.NoteTitle,
            Note: surgeonNote.Note
          };

          const response = await editSurgeonNotes(surgeonNote.ID, postData);
          const { message, status } = response;
          if (status) {
            dispatch(reset('surgeonNoteForm'));
            onGoBack(goBack);
          } else {
            notify({ type: 'error', message });
          }
        } else {
          const postData = {
            NoteTitle: surgeonNote.NoteTitle,
            Note: surgeonNote.Note,
            SurgeonName: surgeonData.SurgeonName
          };

          const response = await addSurgeonNotes(postData);
          const { message, status } = response;
          if (status) {
            dispatch(reset('surgeonNoteForm'));
            onGoBack(goBack);
          } else {
            notify({ type: 'error', message });
          }
        }
        // setLoader(false);
      } else {
        notify({ type: 'error', message: 'You must have an internet connection. Please check you connection and try again.', time: 3 });
        return false;
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _fetchSurgeonNote = () => {
    try {
      const {
        params, surgeonNote
      } = this.props;

      const { fieldPageToShow } = this.state;
      const id = params.hasOwnProperty('id') ? params.id : '';
      if (id !== '') {
        this.setState({
          fieldPageToShow: !fieldPageToShow,
          surgeonNote: { ...surgeonNote, ID: id },
        }, () => {
          this._fillForm();
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _fillForm = () => {
    try {
      const { dispatch } = this.props;
      const { surgeonNote } = this.state;
      Object.keys(surgeonNote).map((key) => {
        dispatch(change('surgeonNoteForm', key, surgeonNote[key]));
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onRemoveSurgeonNote = async () => {
    try {
      const {
        surgeonNote, setSurgeonNote, online, setLoader, notify
      } = this.props;
      if (online) {
        setLoader(true);
        const response = await removeSurgeonNotes(surgeonNote.ID);
        const { result, message } = response;
        if (result === 'success') {
          setSurgeonNote({});
          browserHistory.push('/surgeon-notes');
        } else {
          notify({ type: 'error', message });
        }

        // setLoader(false);
      } else {
        notify({
          type: 'error',
          message: 'You must have as internet connection. Please check your connection and try again.'
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSaveCancelOrBack = () => {
    try {
      const {
        setSurgeonNote, goBack
      } = this.props;
      setSurgeonNote({});
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSurgeonNoteSave = () => {
    try {
      const {
        notify, surgeonNote
      } = this.props;

      if (Object.keys(surgeonNote).length > 0) {
        if (surgeonNote.NoteTitle === '') {
          notify({ type: 'error', message: 'Please enter title.' });
          return;
        }

        if (surgeonNote.Note === '') {
          notify({ type: 'error', message: 'Please enter note.' });
          return;
        }

        this._onSubmit();
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  UNSAFE_componentWillMount() {
    try {
      this._fetchSurgeonNote();
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  render() {
    const { handleSubmit } = this.props;
    const {
      surgeonNote,
      fieldPageToShow,
      surgeonData
    } = this.state;

    return (
      <section className="list-section">
        {
          fieldPageToShow
            ? (
              <form onSubmit={handleSubmit(this._onSubmit)} form="surgeonNoteForm">
                <Header
                  actionButton={(surgeonNote.ID !== '') ? { title: 'Save' } : { title: 'Save' }}
                  actionButtonExtra={(surgeonNote.ID !== '') ? {
                    title: <i className="fas fa-trash" />,
                    type: 'button',
                    onClick: () => {
                      this.deleteSurgeonNote.show();
                    }
                  } : ''}
                  title={(surgeonNote.ID !== '') ? 'Edit Surgeon Note' : 'Add Surgeon Note'}
                  goBack={this._onGoBack}
                />
                <section className="case-details-section pb-5 mb-4">
                  <div className="container">

                    <div className="row mb-4">
                      <div className="col bg-card" style={{ backgroundColor: '#000' }}>
                        <p className="m-1">
                          {
                            surgeonNote.ID !== '' ? surgeonNote.SurgeonName : surgeonData.SurgeonName
                          }
                        </p>
                      </div>
                    </div>

                    <div className="row gx-2">

                      <div className="col-12">
                        <div className="case-data">
                          <label htmlFor="NoteTitle">Title</label>
                          <Field
                            type="text"
                            name="NoteTitle"
                            className="form-control"
                            placeholder="Enter title for surgeon note"
                            component={renderField}
                            validate={[required]}
                            onChange={this._onChangeName}
                          />
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="case-data">
                          <label htmlFor="Comments">Note</label>
                          <Field
                            type="textarea"
                            name="Note"
                            id="preferenceOfficeNotes"
                            className="form-control"
                            placeholder="Enter surgeon note"
                            component={renderField}
                            validate={[required]}
                            onChange={this._onChangeComments}
                            row="10"
                            style={{ height: '150px' }}
                          />
                        </div>
                      </div>

                    </div>

                  </div>
                </section>
              </form>
            )
            : (
              <ChooseSurgeon
                pageTitle="Surgeon"
                onGoBackSurgeon={this._onGoBack}
                onSelect={(value) => this._onFieldSelected(value)}
              />
            )
        }

        <NoSaveSurgeonNoteModal
          onSurgeonNoteYes={this._noSaveSurgeonNoteYes}
        />
        <SaveSurgeonBackModal
          onSave={this._onSurgeonNoteSave}
          onCancel={this._onSaveCancelOrBack}
        />
        <DeleteSurgeonNoteConfirmation
          onRemove={this._onRemoveSurgeonNote}
        />

      </section>
    );
  }
}

const withForm = reduxForm({
  form: 'surgeonNoteForm',
});

export default withOnline(
  withForm(
    withGoBack(
      withNotify(
        withLoader(
          withSurgeonNotes(
            AddSurgeonNote
          )
        )
      )
    )
  )
);
